<template xmlns="http://www.w3.org/1999/html">
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_product" src="@/assets/images/icon_product.png" alt=""/>完善订单</span>
      <el-steps :active="3" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 产品选择" icon="el-icon-thumb"></el-step>
        <el-step title="2 购物车确认" icon="el-icon-shopping-cart-full"></el-step>
        <el-step title="3 完善订单信息" icon="el-icon-edit"></el-step>
        <el-step title="4 提交完成订单" icon="el-icon-document-checked"></el-step>
      </el-steps>
      <el-button class="but2">
        <img class="icon_orderList" src="@/assets/images/icon_orderList.png" alt=""/>
        <span class="sp2">商品清单</span>
      </el-button>
      <el-table size="small" :data="goodsList" style="width: 100%" border>
        <el-table-column align="center" prop="goodsCode" label="商品编码"></el-table-column>
        <el-table-column align="center" prop="goodsName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="goodsAlias" label="代号"></el-table-column>
        <el-table-column align="center" prop="goodsRule" label="规格"></el-table-column>
        <el-table-column align="center" prop="weight" label="数量">
          <template slot-scope="scope">
            <span>{{ scope.row.weight + " " + scope.row.baseUnitName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="amount" label="辅助数量">
          <template slot-scope="scope">
            <span>{{ scope.row.amount + " " + (scope.row.assistUnitName == null ? "包" : scope.row.assistUnitName) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="but2" style="margin-top: 20px">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">填写订单收货信息</span>
      </el-button>
      <!--业务员订单信息展示-->
      <el-form class="form" v-if="currentUser.userType === 1" :disabled="loading">
        <el-form-item class="sp3">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">提货人：
            <el-select v-model="selectedCustomer"
                       placeholder="请选择"
                       size="small"
                       style="margin-top: 20px"
                       @change="getDeliveryType();getBalance();queryCenterSettle()"
                       filterable
                       :filter-method="dataFilter"
                       ref="select"
                       :clearable="showClose"
                       @blur.native.capture="onblur"
                       @hook:mounted="cancelReadOnly"
                       @visible-change="cancelReadOnly">
              <el-option
                v-for="(item,index) in customerOption"
                :key="item.id"
                :label="item.name+' & '+item.number"
                :value="item.id">
              </el-option>
            </el-select>
          </span>
        </el-form-item>
        <el-form-item class="sp3">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">联系电话：{{personInfo.phoneNo}}</span>
        </el-form-item>
        <el-form-item class="sp3" v-if="isShowGift === '1'">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">是否赠料：
            <el-select v-model="isGift" placeholder="请选择" size="small">
              <el-option
                v-for="item in giftList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </span>
        </el-form-item>
        <el-form-item class="sp3">
          <span v-if="selectedCustomer === ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">选择提货人后展示发货详情</span>
          </span>
          <span v-else v-for="(storage,index) in storageOrgInfo">
            <el-radio v-model="stoDef" :label="index" @change="getBalance()">
              <span style="color: black">
                <span style="font-weight: bold">发货公司：</span>{{storage.name}}
                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ storage.orgCompany.name }}
              </span>
            </el-radio><br>
          </span>
        </el-form-item>
        <el-form-item class="sp3">
          <span style="margin-left: 10px">客户余额：</span>
          <span class="balance">{{balance}}</span>
        </el-form-item>
      </el-form>

      <!--客户订单信息展示-->
      <el-form class="form" v-if="currentUser.userType === 2" :disabled="loading">
        <el-form-item class="sp3" style="margin-top: 20px">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">提货人：{{customerInfo.name}}</span>
        </el-form-item>
        <el-form-item class="sp3">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">联系电话：{{linkManInfo.mobile}}</span>
        </el-form-item>
        <el-form-item class="sp3">
<!--          <el-radio>-->
<!--            <span style="color: black">-->
<!--              <span style="font-weight: bold">发货公司：</span>{{this.storageOrgDef.name}}-->
<!--              <span style="font-weight: bold;margin-left: 20px">付款公司：</span>{{ this.storageOrgDef.orgCompany.name }}-->
<!--            </span>-->
<!--          </el-radio>-->
          <!-- 网页端允许客户选择发货组织和财务组织-->
          <span v-for="(storage,index) in storageOrgInfo">
            <el-radio v-model="stoDef" :label="index">
              <span style="color: black">
                <span style="font-weight: bold">发货公司：</span>{{storage.name}}
                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ storage.orgCompany.name }}
              </span>
            </el-radio><br>
          </span>
        </el-form-item>
      </el-form>
      <el-button class="but2" style="margin-top: 20px">
        <img class="icon_car" src="@/assets/images/icon_car.png" alt=""/>
        <span class="sp2">支付和配送方式</span>
      </el-button>
      <el-form class="form" :disabled="loading">
        <el-form-item class="sp3" style="margin-top: 20px">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">配送方式：</span>
          <template>
            <el-radio v-model="deliveryType" label="1" style="margin-left: 10px">
              <span style="color: black">自提</span>
            </el-radio>
            <el-radio v-model="deliveryType" label="0">
              <span style="color: black">送货</span>
            </el-radio>
          </template>
        </el-form-item>
        <el-form-item class="sp3">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">提货日期：</span>
          <el-date-picker style="margin-left: 5px" value-format="yyyy-MM-dd" v-model="deliveryDate" :picker-options="pickerOptions"></el-date-picker>
          <span style="color: rgb(143, 143, 143);">（可选今天起1个月内的日期）</span>
        </el-form-item>
        <el-form-item class="sp3">
          <div style="display: flex;margin-left: 10px">
          <span>订单备注：</span>
          <el-input class="remark" type="textarea" :rows="3" v-model="remark"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <el-footer class="footer" v-if="currentUser.userType === 1">
        <el-button class="but" @click="personSubmit('orderForm')" :loading="loading">提交订单信息</el-button>
      </el-footer>
      <el-footer class="footer" v-if="currentUser.userType === 2">
        <el-button class="but" @click="submit('orderForm')" :loading="loading">提交订单信息</el-button>
      </el-footer>
      </el-main>
  </el-container>
</template>

<script>
import {getBalanceAmount, pushBillToEAS} from "../../../api/system/order";
import {
  queryCenterSettle,
  queryCustomerLinkmanById,
  queryPersonListById
} from "../../../api/system/customer";
import {queryBySale} from "../../../api/system/org-storage";
import {removeByCode} from "../../../api/system/cart";
import {queryCustomerListById, queryPersonSaleInfoById} from "../../../api/system/person";
import {getDeliveryType, setDeliveryType} from "../../../api/system/behavior-storage";

export default {
  name: "index",
  data() {
    return {
      currentUser:'',
      saleOrgName: '',//销售组织
      goodsList: [],//物料列表
      deliveryType: '1',//交货方式 自提1 送货0
      stoDef: '',//默认发货组织和财务组织
      storageOrgInfo: [],//发货组织和财务组织列表
      storageOrgDef: { //默认发货组织和财务组织
        id: '',
        name: '',
        orgCompany: {
          name: ''
        }
      },
      storageOrgDefBak: { //默认发货组织和财务组织
        id: '',
        name: '',
        orgCompany: {
          name: ''
        }
      },
      personInfo: [{ //业务员
        name: ''
      }],
      customerInfo: [{ //客户
        name: ''
      }],
      linkManInfo: { //客户联系人
        mobile: '',
      },
      customerList: [],//客户列表
      customerOption: [],
      personId: '',
      customerId: '',
      companyId: '',
      storageOrgId: '',
      deliveryDate: null,
      remark: '',
      billNumber: '',
      billAmount: '',
      billCustomer: '',
      billBalance: '',
      selectedCustomer:'',
      balance: 0,
      timeOptionRange: '',
      giftList:[{
        value: '0',
        label: '否'
      }, {
        value: '1',
        label: '是'
      }],
      isGift:'0',//是否赠料
      isShowGift:'0',//是否可订赠料
      isShowAmount: '1',//订货成功是否展示金额
      isShowBalance: '0',//订货成功是否可查询余额
      isShowPrice: '0',//是否展示价格
      loading:false,
      // balLoading:false,
      showClose:false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 29 * 8.64e7 // 限制时间8天内
        }
      },
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")

    this.goodsList = JSON.parse(this.$route.params.goodsList) //结算物料列表
    this.selectedCustomer = this.$route.params.selectedCustomer

    //若已选择客户，则直接获取其发货组织对应关系
    if(this.selectedCustomer !== null && this.selectedCustomer !== '' && this.currentUser.userType === 1){
      this.queryCenterSettle()
    }

    //获取销售组织默认库存财务组织
    this.queryOrgBySaleOrg()
    //获取用户销售组织
    this.getUserSaleInfo()
  },
  methods: {
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getUserSaleInfo(){
      //获取原始销售组织列表
      this.queryOrgBySaleOrg2()
      if(this.currentUser.userType === 1){
        this.personInfo = this.currentUser.person
        //查询业务员对应客户
        this.queryCustomer()
        //查询业务员是否可订赠料
        this.querySaleInfoById()
      }else if(this.currentUser.userType === 2){
        this.customerInfo = this.currentUser.customer
        //获取客户对应业务员
        this.queryPersonListById(this.currentUser.customer.number)
        //获取客户联系人
        this.queryCustomerLinkmanById()
        //获取配送方式
        this.getDeliveryType()
      }
    },
    querySaleInfoById(){
      let param = {}
      param.saleOrgId = this.saleOrgId
      param.personNumber = this.currentUser.username
      queryPersonSaleInfoById(param).then(res => {
        this.isShowGift = res.data[0].isShowGift
      }).catch({})
    },
    queryCenterSettle(){
      if(this.currentUser.userType === 2){
        this.selectedCustomer = this.currentUser.customer.id
      }
      if(this.selectedCustomer === ''){
        return
      }
      let param = {}
      param.saleOrgId = this.saleOrgId
      param.customerId = this.selectedCustomer
      queryCenterSettle(param).then(res => {
        //有客户与发货组织对应关系
        if(res.code === 200 && res.data !== null){
          //判断为业务员登录
          // if(this.currentUser.userType === 1){
          //不存在集中结算
          if(res.data.centreSettle === '0'){
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === res.data.storageOrgId) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //插入一条，设置为默认的财务组织
          }else{
            let currentStorageOrg = this.storageOrgInfoTemp[0];
            currentStorageOrg.id = res.data.storageOrgId
            currentStorageOrg.name = res.data.storageOrgName
            //设置为默认的财务组织
            currentStorageOrg.orgCompany.id = this.storageOrgDefBak.orgCompany.id
            currentStorageOrg.orgCompany.name = this.storageOrgDefBak.orgCompany.name
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === currentStorageOrg.orgCompany.id) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //判断组织列表里是否包含集中结算组织
            if(!this.storageOrgInfo.includes(currentStorageOrg)){
              this.storageOrgInfo.unshift(currentStorageOrg);
            }
          }
          //查询客户余额
          if(this.currentUser.userType === 1) {
            this.getBalance();
          }

        }
        // else{
        //   if(this.currentUser.userType === 1){
        //     this.queryOrgBySaleOrg()
        //   }
        // }
      }).catch({

      })
    },
    //获取客户配送方式
    getDeliveryType(){
      let param = {}
      if(this.currentUser.userType === 1){
        if(this.selectedCustomer === '' || this.selectedCustomer === undefined){
          return
        }
        param.customerId = this.selectedCustomer
      } else if(this.currentUser.userType === 2){
        param.customerId = this.customerInfo.id
      }
      // console.log(param)
      getDeliveryType(param).then(res => {
        // console.log("getDeliveryType");
        // console.log(res);
        if(res.data !== null){
          this.deliveryType = res.data.id
        }else{
          this.deliveryType = '1'
        }
      }).catch({

      })
    },
    //设置客户提货方式
    setDeliveryType(){
      let param = {}
      param.deliveryType = this.deliveryType
      param.deliveryTypeName = this.deliveryType === '1' ? '自提' : '送货'
      if(this.currentUser.userType === 1){
        param.customerId = this.selectedCustomer
      }else{
        param.customerId = this.customerInfo.id
      }
      // console.log(param)
      setDeliveryType(param).then(res => {
        // console.log("setDeliveryType");
        // console.log(res);
      }).catch({

      })
    },
    queryPersonListById(){
      let param = {}
      param.customerNumber = this.currentUser.username
      param.orgSaleId = this.saleOrgId
      let paramList = []
      paramList.push(param)
      queryPersonListById(param).then(res => {
        if(res.code === 200){
          this.personInfo = res.data
        }else{
          this.$modal.msgError("获取您的业务员信息失败，请重试")
        }
      });
    },
    //获取客户联系人
    queryCustomerLinkmanById(){
      let param = {}
      param.id = this.currentUser.customer.id
      param.saleOrgId = this.saleOrgId
      queryCustomerLinkmanById(param).then(res => {
        if(res.code === 200){
          this.linkManInfo = res.data
        }else{
          this.$modal.msgError("获取您的联系人信息失败，请重试")
        }
      });
    },
    queryOrgBySaleOrg2(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if (res.code === 200) {
          this.storageOrgInfoTemp = res.data
        }
        //如果已经选择了客户，则直接获取当前客户余额
        if(this.selectedCustomer !== '' && this.currentUser.userType === 1){
          this.getBalance()
        }
      });
    },
    queryOrgBySaleOrg(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if(res.code === 200){
          this.storageOrgInfo = res.data
          //设置默认的发货组织和财务组织
          for(let i = 0; i < this.storageOrgInfo.length; i++){
            if(this.storageOrgInfo[i].isDefault === 1){
              this.storageOrgDef = this.storageOrgInfo[i]
              this.storageOrgDefBak = this.storageOrgInfo[i]
              this.stoDef = i
              break;
            }
          }
          if(this.currentUser.userType === 2){
            this.queryCenterSettle();
          }

        }else{
          this.$modal.msgError("获取您的客户失败，请联系营业室进行维护")
        }
      });
    },
    queryCustomer(){
      let param = {};
      let saleOrgList = [{id:this.saleOrgId}]
      param.number = this.personInfo.number
      param.orgSaleList = saleOrgList
      queryCustomerListById(param).then(res => {
        if(res.code === 200){
          this.customerList = res.data
          this.customerOption = res.data
          if(this.selectedCustomer !== '') {
            this.getDeliveryType()
          }

        }else{
          this.$modal.msgError("获取您的客户失败，请联系营业室进行维护")
        }
      });
    },

    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customerOption = this.customerList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase()) || !!~item.number.indexOf(val) || !!~item.number.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customerOption = this.customerList;
      }
    },

    getBalance(){
      let param = {};
      if(this.selectedCustomer === ''){
        this.$modal.msg("请选择提货人")
        return
      }
      param.companyID = this.storageOrgInfo[this.stoDef].orgCompany.id
      param.customerID = this.selectedCustomer
      getBalanceAmount(param).then(res => {
        if(res.code === 200){
          this.balance = res.data.data.balance
          this.billBalance = res.data.data.balance
        }else{
          this.$modal.msgError("获取客户余额失败，请重试")
        }
      }).catch(()=>{});
    },
    personSubmit(){
      if(this.selectedCustomer === ''){
        this.$modal.msg("请选择提货人")
        return
      }
      if(this.deliveryDate === null){
        this.$modal.msg("请选择提货日期")
        return
      }
      this.loading = true
      let saleOrder = {}
      saleOrder.personId = this.personInfo.id
      saleOrder.customerId = this.selectedCustomer
      saleOrder.saleOrgId = this.saleOrgId
      saleOrder.storageOrgId = this.storageOrgInfo[this.stoDef].id
      saleOrder.companyId = this.storageOrgInfo[this.stoDef].orgCompany.id
      saleOrder.orderSourceType = 1
      saleOrder.remark = this.remark
      saleOrder.deliveryType = this.deliveryType
      saleOrder.isCenterSettle = 0
      if(saleOrder.storageOrgId !== saleOrder.companyId){
        saleOrder.isCenterSettle = 1
      }

      let materialInfo = []
      for(let i = 0; i < this.goodsList.length; i++){
        let material = {}
        material.MaterialID = this.goodsList[i].goodsId
        // material.MeasuerUnit = 'T'
        material.measurementId = this.goodsList[i].baseUnitId
        material.qty = this.goodsList[i].weight
        material.assistUnitId = this.goodsList[i].assistUnitId
        material.assistQty = this.goodsList[i].amount
        material.deliveryDate = this.deliveryDate
        material.isPresent = this.isGift
        materialInfo.push(material)
      }
      saleOrder.materialInfo = materialInfo

      let saleOrderList = [];
      saleOrderList.push(saleOrder)
      // console.log(saleOrderList)
      pushBillToEAS(saleOrderList).then(res => {
        if(res.code === 200){
          this.loading = false
          // console.log('成功')
          // console.log(res.data)
          if(res.data[0].success === false){
            this.$modal.msgError(res.data[0].msg)
            return
          }
          this.billNumber = res.data[0].billNumber
          this.billAmount = res.data[0].billAmount
          // console.log(this.billAmount)
          for(let i = 0; i < this.customerList.length; i++){
            if(this.customerList[i].id === this.selectedCustomer){
              this.billCustomer = this.customerList[i].name
              break;
            }
          }
          this.setDeliveryType() //设置提货方式
          this.batchDelete() //批量删除购物车
          this.toSuccessPage() //跳转成功页面

        }else{
          // console.log('失败')
          // console.log(res.data)
          this.$modal.msgError("订单提交失败")
        }
      });
    },
    submit () {
      if(this.deliveryDate === null){
        this.$modal.msg("请选择提货日期")
        return
      }
      this.loading = true
      let saleOrder = {}
      saleOrder.personId = this.personInfo[0].id
      saleOrder.customerId = this.customerInfo.id
      saleOrder.saleOrgId = this.saleOrgId
      // saleOrder.storageOrgId = this.storageOrgDef.id
      // saleOrder.companyId = this.storageOrgDef.orgCompany.id
      saleOrder.storageOrgId = this.storageOrgInfo[this.stoDef].id
      saleOrder.companyId = this.storageOrgInfo[this.stoDef].orgCompany.id
      saleOrder.orderSourceType = 0
      saleOrder.remark = this.remark
      saleOrder.deliveryType = this.deliveryType
      saleOrder.isCenterSettle = 0
      if(saleOrder.storageOrgId !== saleOrder.companyId){
        saleOrder.isCenterSettle = 1
      }
      let materialInfo = []
      for(let i = 0; i < this.goodsList.length; i++){
        let material = {}
        material.MaterialID = this.goodsList[i].goodsId
        // material.MeasuerUnit = 'T'
        material.measurementId = this.goodsList[i].baseUnitId
        material.qty = this.goodsList[i].weight
        material.assistUnitId = this.goodsList[i].assistUnitId
        material.assistQty = this.goodsList[i].amount
        material.deliveryDate = this.deliveryDate
        material.isPresent = '0'
        materialInfo.push(material)
      }
      saleOrder.materialInfo = materialInfo

      let saleOrderList = [];
      saleOrderList.push(saleOrder)
      // console.log(saleOrderList)
      pushBillToEAS(saleOrderList).then(res => {
        if(res.code === 200){
          this.loading = false
          if(res.data[0].success === false){
            this.$modal.msgError(res.data[0].msg)
            return
          }
          // console.log(res.data)
          this.billNumber = res.data[0].billNumber
          this.billAmount = res.data[0].billAmount
          this.billCustomer = this.customerInfo.name
          this.setDeliveryType() //设置提货方式
          this.batchDelete()
          this.toSuccessPage()

        }else{
          this.$modal.msgError("订单提交失败，请重试")
        }
      });
    },
    //订货成功批量删除购物车物料
    batchDelete(){
      let cart = [];
      for(let i = 0; i < this.goodsList.length; i++){
        let goods = {};
        goods.goodsCode = this.goodsList[i].goodsCode;
        goods.orgSaleId = this.saleOrgId;
        cart.push(goods)
      }
      // console.log(cart)
      removeByCode(cart).then(res=>{
        if (res.code === 200) {
          console.log('购物车物料删除成功')
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    toSuccessPage(){
      if(this.currentUser.userType === 1){
        this.getBalance()
      }else if (this.currentUser.userType === 2){
        if(this.isShowAmount === '0'){
          this.billAmount = ''
        }
        if(this.isShowBalance === '0'){
          this.billBalance = ''
        }
      }
      this.$router.push({name: "OrderSuccess",params: {'billNumber':this.billNumber,'billAmount':this.billAmount,'selectedCustomer':this.selectedCustomer,'billCustomer':this.billCustomer,'billBalance':this.billBalance}});
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
  }
  .title{
    margin-top: 10px;
    margin-left: 20px;
  }
  .icon_product{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .sp1{
    color: rgb(239, 51, 69);
    font-weight: bold;
    line-height: 20px;
  }
  .footer{
    margin-top: 20px;
    text-align: center;
  }
  .but{
    width: 160px;
    font-size: 16px;
    color: white;
    border: none;
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
    border-radius: 20px;
  }
  .remark{
    width: 500px;
    margin-left: 5px;
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .balance{
    color: rgb(239, 51, 69);
    margin-left: 20px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_orderList{
    /* 减去顶层 */
    position: absolute;
    width: 14px;
    height: 16px;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .icon_car{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .sp3{
    margin-left: 70px;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
</style>
